module.exports = __webpack_public_path__ + "img/kova_yes.8cb72cd1.png";